import { takeLatest, select, call, put } from 'redux-saga/effects';
import { Customers } from '@grandvisionhq/api-client';
import { toast } from '@grandvisionhq/common';
import { crossOriginAuthentication } from '../auth.js';
import { account } from '../customer-service.js';
import { getAuth, getRouting } from '../selectors.js';
import { isLoggedInPasswordless, isLoggedIn } from '../state.js';
import { getToken } from '../token-service.js';
import { getAuth0ErrorCode } from './Utils/get-auth0-error-code.js';
import { RESET_PASSWORD, UPDATE_PASSWORD, CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, UPDATE_PASSWORD_SUCCESS, resetPasswordSuccess, resetPasswordFailed, updatePasswordFailed, updatePasswordSuccess, changePasswordFailed, changePasswordSuccess } from './actions.js';
import { loginWithPassword } from '../Login/actions.js';

function* onResetPassword(action) {
    const authState = yield select(getAuth);
    try {
        const stateParams = {
            targetAction: 'forgotPassword'
        };
        const { protocol , host  } = window === null || window === void 0 ? void 0 : window.location;
        const redirectUri = `${protocol}//${host}/${authState.routing.basePath}/callback`;
        const requestPayload = {
            emailAddress: action.payload.email,
            state: JSON.stringify(stateParams),
            loginRedirectUrl: redirectUri
        };
        yield call(Customers.Password.resetPassword, authState.apiUrl, requestPayload);
        yield put(resetPasswordSuccess({
            email: action.payload.email
        }));
    } catch (err) {
        yield put(resetPasswordFailed(err));
    }
}
function* onUpdatePassword(action) {
    const authState = yield select(getAuth);
    if (!isLoggedInPasswordless(authState)) {
        yield put(updatePasswordFailed(new Error(`Can only update users' password when they're logged-in with passwordless link`)));
        return;
    }
    const token = yield call(getToken, 'gv::update:password', 'email', 'profile', 'openid');
    try {
        yield call(account.changePassword, authState.apiUrl, token, authState.userId, action.payload.password);
        yield put(updatePasswordSuccess({
            password: action.payload.password
        }));
        yield call(toast.success, 'account.updatePassword.success');
    } catch (err) {
        yield put(updatePasswordFailed(err));
    }
}
const convertPayload = (payload)=>({
        email: payload.email,
        oldPassword: payload.currentPassword,
        password: payload.newPassword
    })
;
function* onChangePassword(action) {
    const authState = yield select(getAuth);
    if (!isLoggedIn(authState)) {
        yield put(changePasswordFailed(new Error(`Can only update users' password when they're logged-in`)));
        return;
    }
    const changePasswordPayload = convertPayload(action.payload);
    try {
        const token = yield call(getToken);
        yield call(Customers.Password.changePassword, authState.apiUrl, token, authState.userId, changePasswordPayload);
        yield put(changePasswordSuccess({
            password: changePasswordPayload.password
        }));
    } catch (err) {
        // Get auth0ErrorCode value from error string, if it exists
        const auth0ErrorCode = (err === null || err === void 0 ? void 0 : err.message) ? getAuth0ErrorCode(err.message) : undefined;
        yield put(changePasswordFailed(auth0ErrorCode || err));
    }
}
function* loginAfterPasswordUpdate(action) {
    const authState = yield select(getAuth);
    if (!isLoggedInPasswordless(authState)) {
        console.error(`User is not logged in via passwordless method. Login state: ${authState.state}. Login type: ${authState.type}.`);
        return;
    }
    yield call(crossOriginAuthentication, authState.email, action.payload.password);
}
function* loginAfterPasswordChange(action) {
    const authState = yield select(getAuth);
    const routing = yield select(getRouting);
    if (!isLoggedIn(authState)) {
        console.error(`User is not regularly logged in. Login state: ${authState.state}. Login type: ${authState.type}.`);
        return;
    }
    const returnPath = routing && encodeURIComponent(`${routing.basePath}/${routing.routes.settings}/${routing.routes.changePassword}?changePasswordResult=success`);
    yield put(loginWithPassword({
        email: authState.email,
        password: action.payload.password,
        returnPath
    }));
}
var resetPasswordSagas = [
    takeLatest(RESET_PASSWORD, onResetPassword),
    takeLatest(UPDATE_PASSWORD, onUpdatePassword),
    takeLatest(CHANGE_PASSWORD, onChangePassword),
    takeLatest(CHANGE_PASSWORD_SUCCESS, loginAfterPasswordChange),
    takeLatest(UPDATE_PASSWORD_SUCCESS, loginAfterPasswordUpdate), 
];

export { convertPayload, resetPasswordSagas as default, loginAfterPasswordChange, loginAfterPasswordUpdate, onChangePassword, onResetPassword, onUpdatePassword };
//# sourceMappingURL=sagas.js.map
